var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 106,
    viewBox: "0 0 116 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.51 82.4245L68.274 11.8741C63.7375 3.91965 52.2623 3.91966 47.7258 11.8741L7.49009 82.4245C2.99746 90.302 8.69054 100.092 17.7642 100.092H98.2358C107.309 100.092 113.003 90.302 108.51 82.4245ZM73.4111 8.94875C66.6063 -2.98292 49.3935 -2.98292 42.5887 8.94877L2.35302 79.4992C-4.38593 91.3154 4.1537 106 17.7642 106H98.2358C111.846 106 120.386 91.3154 113.647 79.4991L73.4111 8.94875Z",
    fill: "#EB6363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9563 79.4128C60.9563 81.0443 59.6327 82.3669 58 82.3669C56.3672 82.3669 55.0436 81.0443 55.0436 79.4128C55.0436 77.7813 56.3672 76.4587 58 76.4587C59.6327 76.4587 60.9563 77.7813 60.9563 79.4128Z",
    fill: "#EB6363"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 67.5962C59.6327 67.5962 60.9563 66.2736 60.9563 64.6421V35.1008C60.9563 33.4693 59.6327 32.1467 58 32.1467C56.3672 32.1467 55.0436 33.4693 55.0436 35.1008V64.6421C55.0436 66.2736 56.3672 67.5962 58 67.5962Z",
    fill: "#EB6363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.6f6307ab9d91f531ed1caff44fbce422.svg";
export { ForwardRef as ReactComponent };